import { ArrowSmallRightIcon } from '@heroicons/react/20/solid';
import React from 'react';

interface Props {
  backgroundColor: string;
  textColor: string;
  icon?: React.ReactNode;
  iconClasses?: string;
  count: string | React.ReactNode;
  text: string;
}

export const CardTitle: React.FC<Props> = (props) => {
  const { backgroundColor, textColor, icon, count, text, iconClasses } = props;

  return (
    <div className="flex items-center gap-3">
      {icon && (
        <div className={`flex items-center ${backgroundColor} p-1.5 h-7 w-7 rounded-sm`}>
          <div>
            <div className={`rounded-sm h-4 w-4 ${iconClasses}`}>{icon}</div>
          </div>
        </div>
      )}
      <div className={`flex items-center ${backgroundColor} px-1 rounded-sm`}>
        <h6 className={`text-lg ${textColor} font-bold`}>{count}</h6>
      </div>
      <div className="flex items-center gap-1">
        <div className="truncate text-sm font-medium leading-4 whitespace-normal text-gray-900">
          {text}
        </div>
        <ArrowSmallRightIcon className="h-4 w-4 text-gray-700 group-hover:text-blue-900 transition-colors" />
      </div>
    </div>
  );
};
